<button class="nobis-button" [ngClass]="mode" [disabled]="disabled">
  <ng-content></ng-content>
</button>
